// ================================
// pages/legal/RefundPolicy.js
// ================================
import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';
 const RefundPolicy = () => (
  <div className="legal-page">
    <div className="legal-container">
      <div className="legal-header">
        <Link to="/" className="legal-back">← Back</Link>
        <h1>Refund Policy</h1>
        <p className="legal-date">Last updated: March 7, 2025 — SynexStudio</p>
      </div>

      <section>
        <h2>1. Overview</h2>
        <p>At SynexStudio, we want you to be satisfied with RizzingBot. This policy explains your rights and our refund procedures.</p>
      </section>

      <section>
        <h2>2. Subscription Cancellations</h2>
        <p>You may cancel your subscription at any time through your account settings. Upon cancellation:</p>
        <ul>
          <li>Your subscription remains active until the end of the current billing period</li>
          <li>No further charges will be made after cancellation</li>
          <li>Credits remain available until the period expires</li>
        </ul>
        <p>We do not provide pro-rated refunds for unused subscription time.</p>
      </section>

      <section>
        <h2>3. Refund Eligibility</h2>
        <h3>Eligible for Refund</h3>
        <ul>
          <li>Duplicate charges due to a technical error</li>
          <li>Charges made after a confirmed cancellation</li>
          <li>Significant service outage (more than 72 consecutive hours)</li>
        </ul>
        <h3>Not Eligible for Refund</h3>
        <ul>
          <li>Change of mind after purchase</li>
          <li>Dissatisfaction with AI-generated content</li>
          <li>Credits that have been used</li>
          <li>Accounts terminated for Terms of Service violation</li>
        </ul>
      </section>

      <section>
        <h2>4. Right of Withdrawal (EU)</h2>
        <p>Under EU consumer protection law, you have the right to withdraw within 14 days of purchase, provided you have not started using the service. By purchasing and immediately accessing credits and AI features, you expressly waive this right upon first use.</p>
      </section>

      <section>
        <h2>5. How to Request a Refund</h2>
        <p>Contact us at <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a> with your registered email, the date of the charge, and reason for your request. We will respond within 5 business days.</p>
      </section>

      <section>
        <h2>6. Contact</h2>
        <p><strong>Email:</strong> <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a></p>
        <p><strong>Company:</strong> SynexStudio — Rouen, France</p>
      </section>

      <div className="legal-footer">
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/legal">Legal Notice</Link>
      </div>
    </div>
  </div>
);
 
export default RefundPolicy;